module.exports = __webpack_public_path__ + "static/img/news5.7d45715.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news5.jpg
// module id = Mviu
// module chunks = 1